'use strict';

import React from 'react';
import Header from './HeaderComponent';
import AlbumStore from 'stores/AlbumStore';
import AlbumActions from 'actions/AlbumActions';
import UserStore from 'stores/UserStore';
import API from 'sources/API.js';
// import { browserHistory } from 'react-router';

require('styles/Collect.scss');

class CollectComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userAlbums: AlbumStore.getState().userAlbums,
      openAddAlbum: false,
      newAlbumName: '',
      moreUserAlbum: true, // 是否还有更多
      currentAlbumId: null
    }
    this.onAlbumChange = this.onAlbumChange.bind(this);
    this.toggleAddAlbum = this.toggleAddAlbum.bind(this);
    this.addAlbum = this.addAlbum.bind(this);
    this.newAlbumNameChange = this.newAlbumNameChange.bind(this);
    this.moreAlbums = this.moreAlbums.bind(this);
    this.albumAddMedia = this.albumAddMedia.bind(this);
    this.radioChange = this.radioChange.bind(this);
  }
  componentDidMount() {
    let check = API.checkToken;

    if(UserStore.getState().accessToken) {
      AlbumStore.listen(this.onAlbumChange);
      AlbumActions.fetchUserAlbumList();
    }

    // goole anlaytics
    // window.ga('set', 'page', this.props.location.pathname);
    // window.ga('send', 'pageview');

    // Baidu tongji
    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount() {
    AlbumStore.unlisten(this.onAlbumChange);
  }
  onAlbumChange(state) {
    this.setState({
      userAlbums: state.userAlbums,
      moreUserAlbum: state.moreUserAlbum
    });
  }
  toggleAddAlbum() {
    if(this.state.openAddAlbum === true) {
      this.setState({openAddAlbum: false});
    } else {
      this.setState({openAddAlbum: true});
    }
  }
  addAlbum() {
    if(this.state.newAlbumName){
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'album',
        eventAction: 'create',
        eventLabel: this.state.newAlbumName
      });
      AlbumActions.postAlbum(this.state.newAlbumName);
      this.setState({openAddAlbum: false,newAlbumName:''});
    }
  }
  newAlbumNameChange(e) {
    this.setState({newAlbumName: e.target.value});
  }
  moreAlbums() {
    AlbumActions.fetchUserAlbumList();
  }
  albumAddMedia() {
    window.ga('send', {
      hitType: 'event',
      eventCategory: 'album',
      eventAction: 'collect',
      eventLabel: 'album——media',
      eventValue: `${this.state.currentAlbumId}——${this.props.params.id}`
    });
    AlbumActions.postAlbumAddMedia({
      album_id: this.state.currentAlbumId,
      media_id: this.props.params.id
    });
  }
  radioChange(e) {
    this.setState({currentAlbumId: e.target.value});
  }
  render() {
    let addAlbumModal, moreAlbum;
    if(this.state.openAddAlbum) {
      addAlbumModal = (
        <div className="reveal-overlay">
          <div className="tiny reveal" id="exampleModal1" data-reveal>
            <button className="close-button" aria-label="Close modal" type="button" onClick={this.toggleAddAlbum}>
              <span aria-hidden="true">&times;</span>
            </button>
            <div className="tip mt-10">合辑名不能为空</div>
            <input type='text' value={this.state.newAlbumName} placeholder="合辑名" onChange={this.newAlbumNameChange} />
            <button className="button expanded" onClick={this.addAlbum}>确认</button>
          </div>
        </div>
      );
    }
    if(this.state.moreUserAlbum) {
      moreAlbum = <div className="border-bottom text-center pt-10 pb-10 fz-14" onClick={this.moreAlbums}>更多</div>
    }
    return (
      <div className="collect-component bg-gray">
        {addAlbumModal}
        <Header title="收藏" />
        <div className="desc">
          人人都是时尚地理主编
          <div>
            采编10～15个兴趣点，放入合辑，即可生成一篇你的专属趣闻
          </div>
        </div>
        <div className="row">
          <div className="columns pl-15 pr-15 mt-10">
            <div className="bg-white">
              <div className="border-bottom pl-15 fz-12 tag">
                已有合辑
              </div>
              <fieldset>
                {this.state.userAlbums.map(album=>{
                  if(album && !album.deleted){
                    return (
                      <div className="albums border-bottom" key={album._id}>
                        <input type="radio" name="album" value={album._id} id={album._id} onChange={this.radioChange} />
                        <label htmlFor={album._id}>{album.name?album.name:`未命名合辑`}</label>
                      </div>
                    );
                  }
                })}
              </fieldset>
              {moreAlbum}
              <div className="pl-15 pr-15 clearfix mt-50">
                <button className="button expanded fz-16" onClick={this.albumAddMedia}>确认</button>
                <button className="button expanded fz-16" onClick={this.toggleAddAlbum}>+新建合辑</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CollectComponent.displayName = 'CollectComponent';

// Uncomment properties you need
// CollectComponent.propTypes = {};
// CollectComponent.defaultProps = {};

export default CollectComponent;



// WEBPACK FOOTER //
// ./src/components/CollectComponent.js